/*****************************
 * filename: 日志上报http请求工具
 * author: zjruan
 * createdate: 20190813
 *
 * description:
 * 时间有限，留有优化空间
 * 优化思路：
 * 设置一个日志待上传队列 logQueue，正在上传标识 sendingNum，以及同时上传日志请求上限queueLimit，所有的日志先进入对列，
 * 然后触发消费函数，消费消息，消费之前，首先判断 logQueue 中是否有消息，如果没有，不做处理，如果有，则进入下面步骤
 * 再判断 sendingNum 是否大于 queueLimit，如果大于，则不做处理
 * 如果不大于，则消费上传一条日志，sendingNum 加 1
 * 当上传结束后，不管成功还是失败，sendingNum 减 1，并触发消费函数
 *
 * 若以后随着业务发展，部分日志比较重要，可以在开发失败重试机制
 * updatehistory:
 * // updater date changeinfo
 */

import { toStringify } from './toStringify';
import axios from 'axios';

export default class XhrTool {
  constructor(topic, batchCount = 1) {
    this.topic = topic;
    this.queueLimit = batchCount;
    this.logQueue = [];
    this.sendingNum = 0;
    this.updating = false;
    this.lastTime = Date.now();
    this.useBackupUrl = false;

    setInterval(() => {
      this.noticeConsume();
    }, 10000);

    let logHistoryKey = `lastUnuploadLogHistory_${topic}`;

    if (localStorage && typeof localStorage.getItem == 'function') {
      let history = localStorage.getItem(logHistoryKey);
      if (history) {
        localStorage.removeItem(logHistoryKey);
        let logHistory = JSON.parse(history);
        if (Array.isArray(logHistory) && logHistory.length > 0) {
          this.logQueue = logHistory;
          if (Promise && typeof Promise.resolve == 'function') {
            Promise.resolve().then(() => {
              this._consume(true);
            });
          } else {
            setTimeout(() => {
              this._consume(true);
            }, 0);
          }
        }
      }
    }
    window.addEventListener('beforeunload', () => {
      if (
        this.logQueue.length > 0 &&
        localStorage &&
        typeof localStorage.setItem == 'function'
      ) {
        localStorage.setItem(logHistoryKey, JSON.stringify(this.logQueue));
      }
    });
  }

  createAxiosInstance() {
    this.axiosInstance = axios.create({
      timeout: 30 * 1000,
      headers: {
        'x-log-apiversion': '0.6.0',
        'x-log-bodyrawsize': 1234,
      },
    });
  }

  /**
   * 发送日志
   * @param {string} url 日志上传 url
   * @param {obj} param 上传信息
   */
  send(url, param, backupUrl) {
    let item = {
      url,
      param,
      backupUrl,
    };
    this.logQueue.push(item);
    setTimeout(() => {
      this.noticeConsume();
    }, 0);
  }

  noticeConsume() {
    // 如果当前正在上报，或者距离上一次上报时间操作 15s，则触发消费逻辑
    // 15 逻辑，是防止由于某些原因，导致消费中断，但是 updating 状态没有被更新，导致无法正常消费
    if (!this.updating || Date.now() - this.lastTime > 15000) {
      this._consume();
    }
  }

  /**
   * 日志消费函数
   * @param {boolean} force 是否强制消费
   */
  _consume(force) {
    this.updating = true;
    // 如果日志条数操作10条，或者距离上一次上报时间超过10s
    if (
      this.logQueue.length >= this.queueLimit ||
      Date.now() - this.lastTime > 10000 ||
      force
    ) {
      let logsItem = this.logQueue.splice(0, this.queueLimit);

      if (logsItem.length == 0) {
        this.updating = false;
        return;
      }

      let url = logsItem[0].url;
      let backupUrl = logsItem[0].backupUrl;
      let logs = logsItem.map((logItem) => {
        let param = logItem.param;
        for (let key in param) {
          if (typeof param[key] != 'string') {
            param[key] = toStringify(param, key);
          }
        }
        return param;
      });
      if (logs.length > 0) {
        let report = {
          __topic__: this.topic,
          __logs__: logs,
          __tags__: {},
        };
        let tryTime = 0;
        let sendReport = () => {
          let tempReport;
          if (this.useBackupUrl) {
            tempReport = Object.assign({}, report);
            tempReport.__tags__ = Object.assign(
              {
                channal: 'kkl_proxy',
              },
              tempReport.__tags__
            );
          } else {
            tempReport = report;
          }
          this.axiosInstance
            .post(this.useBackupUrl ? backupUrl : url, tempReport)
            .then(() => {
              this.lastTime = Date.now();
              this.updating = false;
              this._consume();
            })
            .catch((e) => {
              tryTime++;
              if (tryTime < 3 && !force) {
                if (tryTime > 1) {
                  if (!this.useBackupUrl && backupUrl) {
                    this.useBackupUrl = true;
                  } else if (this.useBackupUrl) {
                    this.useBackupUrl = false;
                  }
                }
                sendReport();
              } else {
                this.updating = false;
              }
            });
        };
        sendReport();
      }
    } else {
      this.updating = false;
    }
  }
}
